import { render, staticRenderFns } from "./AboutDirectSchool.vue?vue&type=template&id=20cf7223&scoped=true&"
import script from "./AboutDirectSchool.vue?vue&type=script&lang=js&"
export * from "./AboutDirectSchool.vue?vue&type=script&lang=js&"
import style0 from "./AboutDirectSchool.vue?vue&type=style&index=0&id=20cf7223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf7223",
  null
  
)

export default component.exports